import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const names = ['Mateo', 'Sofía', 'Lucas', 'Valentina', 'Joaquín', 'Camila', 'Tomás', 'Martina', 'Facundo', 'Agustina'];
const cities = ['Rosario', 'Córdoba', 'Buenos Aires', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Show for 5 seconds
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 10000);
    // Recurring interval (every 20 seconds)
    const interval = setInterval(showPopup, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-118">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -20
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-2xl p-4 flex items-center gap-3 border-l-4 border-[#84cc16] max-w-xs" data-id="element-119">
          <CheckCircle2 className="text-[#84cc16] w-8 h-8 flex-shrink-0" data-id="element-120" />
          <div data-id="element-121">
            <p className="text-sm text-gray-800 font-medium" data-id="element-122">
              <span className="font-bold" data-id="element-123">{buyer.name}</span> de {buyer.city}
            </p>
            <p className="text-xs text-gray-500" data-id="element-124">acaba de comprar el manual</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}